export const FINANCING_COST_PROPERTY_TYPE = {
  INSTITUTION_TYPE: 1, // Kurum Türü
  CREDIT_TYPE: 2, // Kredi Türü
  INTEREST_TYPE: 3, // Faiz Sabit/Değişken
  MATURITY_TYPE: 4, // Vade Sabit/Değişken
  INTEREST_PAYMENT_STATUS: 5, // Faiz Ödeme Peşin/Vadeli
  COLLATERAL_TYPE: 6, // Senet/Nakit
  ASSIGNMENT_PLEDGE_STATUS: 7, // Temlik/Rehin
  COLLATERAL_GUARANTEE: 8, // Ek Teminat Var/Yok
  PROMISSORY_NOTE_COLLECTION_METHOD: 9, // Senet Tahsil Yöntemi
  BRIDGE_FINAL_FUNDING: 10, // Köprü / Nihai Fonlama
  INTEREST_INVOICE: 11 // Faiz Faturası Var/Yok
}
